<template>
  <v-card
    class="pb-4"
    style="height: 100%;"
  >
    <v-img
      class="white--text align-end"
      :src="src"
      aspect-ratio="1"
      height="160px"
    />
    <v-card-subtitle v-if="alt">
      Alt Text: <b>{{ alt }}</b>
    </v-card-subtitle>
    <v-card-subtitle
      class="alt_missing"
      v-else
    >
      <span>
        Alt Text Missing
      </span>
    </v-card-subtitle>
    <v-card-text>
      <a
        :href="src"
        target="_blank"
        style="line-break: anywhere;"
      >
        {{ cleanUrl }}
      </a>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: null
    }
  },
  computed: {
    cleanUrl () {
      if (!this.src) return null

      const { origin, pathname } = new URL(this.src)

      return origin + pathname;
    }
  }
}
</script>
<style scoped>
.alt_missing span{
  color:red;
  font-weight: 500;
}
</style>
